import { IGeometry } from "./IGeometry";

export type ScalingVector = [x: number, y: number];
/**
 * Represents a 2D Point geometry
 */
export class Point implements IGeometry {
  x: number;
  y: number;

  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }

  public scale(scalingVector: ScalingVector): Point;
  public scale(scalingFactor: number): Point;
  public scale(scalingParameter: number | ScalingVector): Point {
    if (Array.isArray(scalingParameter)) {
      const [scalingFactorX, scalingFactorY] = scalingParameter;
      return new Point(this.x * scalingFactorX, this.y * scalingFactorY);
    }
    return new Point(this.x * scalingParameter, this.y * scalingParameter);
  }

  public toOrdinates(): number[] {
    return [this.x, this.y];
  }

  public equals(other: Point) {
    return this.x === other.x && this.y === other.y;
  }

  public toString() {
    return `Point {x: ${this.x}, y: ${this.y}}`;
  }

  public static fromString(pointString: string): Point {
    const [x, y] = pointString
      .replace("Point {", "")
      .replace("}", "")
      .split(", ")
      .map((i) => parseInt(i.split(": ")[1]));
    return new Point(x, y);
  }
}
